export const initialState = {
   data: []
}

const authorizedMenuURLReducer = (state = initialState, action) => {
   switch (action.type) {
      case 'SET_AUTHORIZED_MENU_URL_LIST':
         return {
            ...state,
            data: action.authorizedMenuUrlList
         }
      default:
         return state
   }
}

export default authorizedMenuURLReducer
